export default "__VITE_ASSET__DfqlBZ3x__"